import PlayingChild from './../assets/img/playing_children.jpg'
import HidingChild from './../assets/img/children_hiding.jpg'
import TwoBrothers from './../assets/img/two_brothers_img.webp'
import ComputerImg from './../assets/img/event_frame.webp'
import CarouselImg1 from './../assets/img/carousel_bg.jpg'
import CarouselImg2 from './../assets/img/carousel_bg2.jpg'
import CarouselImg3 from './../assets/img/carousel_bg3.jpg'
import GirlImage from './../assets/img/girl_image.png'
import PencilBag from './../assets/img/pencil_bag.png'
import ExploreServiceFrame from './../assets/img/service_frame.png'
import HeroSectionImg from './../assets/img/hero_section_imgwebp.webp'
import HeroSectionImgJpg from './../assets/img/hero_sectionsm_webp.webp'
import Unio1 from './../assets/img/Union3.svg'
import Unio2 from './../assets/img/Union2.svg'
import LocationImg from './../assets/img/location_img.png'
import CourseDetailImg1 from './../assets/img/course_detail_img1webp.webp'
import CourseDetailImg2 from './../assets/img/course_detail_img2webp.webp'
import UserAvatar from './../assets/img/user_avatarwebp.webp'
import TextBgImg from './../assets/img/text_background_img.jpg'
import CourseImg from './../assets/img/course_frame.webp'
import AddImg from './../assets/img/add_imgwebp.webp'
import GrainLeft from './../assets/img/grain_left.png'
import GrainRight from './../assets/img/grain_right.png'
import AddImgBg from './../assets/img/Featured_addwebp.webp'
import Logo from './../assets/img/logo.png'
import WhiteSpace from './../assets/img/white_space.svg'
import SidebarImg from  './../assets/img/sidebar_imgweb.webp'
import SiblingPlaying from './../assets/img/siblings_playing.svg'

export class Constants {
    static customImages = {
        PlayingChild,
        HidingChild,
        TwoBrothers,
        ComputerImg,
        CarouselImg1,
        CarouselImg2,
        CarouselImg3,
        GirlImage,
        PencilBag,
        ExploreServiceFrame,
        HeroSectionImg,
        Unio1,
        Unio2,
        LocationImg,
        CourseDetailImg1,
        CourseDetailImg2,
        UserAvatar,
        TextBgImg,
        CourseImg,
        AddImg,
        GrainRight,
        GrainLeft,
        AddImgBg,
        Logo,
        WhiteSpace,
        HeroSectionImgJpg,
        SidebarImg,
        SiblingPlaying
        

    };

}

export const BOX_SHADOW = "0px 8px 16px 0px #00000040"

export const DividerBorder="1px solid #D9D9D9"

export const Page_Padding= { xs: "20px", sm: "30px", md: "80px" };

export const Card_Width={ xs: "300px", lg: "340px" };
